import { all, call, put, takeLatest } from 'redux-saga/effects';

import { hideLoader, showLoader } from '@topconagriculture/loader';

import * as actions from './automatedReports.actions';
import { notificationError, notificationSuccess } from '../../../core/helpers/utils/notificationUtils';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import api from '../../../core/api';
import { LoadersNames } from '../../ui/ui.constants';
import { compose403ErrorMessage } from '../../../core/helpers/utils/sagaUtils';

export function* getAutomatedReportsListSaga(action: ReturnType<typeof actions.getAutomatedReportsList.started>) {
  yield put(showLoader(LoadersNames.fetchAutomatedReport));
  try {
    const result = yield call(api.automatedReports.getAutomatedReportsList, action.payload);
    yield put(
      actions.getAutomatedReportsList.done({
        params: action.payload,
        result,
      }),
    );
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
  yield put(hideLoader(LoadersNames.fetchAutomatedReport));
}

export function* createAutomatedReportsSaga(action: ReturnType<typeof actions.createAutomatedReports.started>) {
  const { payload, meta } = action;
  try {
    const result = yield call(api.automatedReports.postAutomatedReport, payload.reportType, payload.data);
    yield put(
      actions.createAutomatedReports.done({
        params: payload,
        result,
      }),
    );
    if (meta && meta.onSuccess) {
      meta.onSuccess();
    }
    yield put(notificationSuccess('reports:automated_report_create_success'));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

export function* updateAutomatedReportsSaga(action: ReturnType<typeof actions.updateAutomatedReports.started>) {
  const { payload, meta } = action;
  try {
    const result = yield call(api.automatedReports.updateAutomatedReport, payload.reportType, payload.data);
    yield put(
      actions.updateAutomatedReports.done({
        params: payload,
        result,
      }),
    );
    if (meta && meta.onSuccess) {
      meta.onSuccess();
    }
    yield put(notificationSuccess('reports:automated_report_edit_success'));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

export function* deleteAutomatedReportsSaga(action: ReturnType<typeof actions.deleteAutomatedReports.started>) {
  const { payload } = action;
  try {
    const result = yield call(api.automatedReports.deleteAutomatedReport, payload.reportType, payload.id);
    yield put(
      actions.deleteAutomatedReports.done({
        params: payload,
        result,
      }),
    );
    yield put(notificationSuccess('reports:automated_report_delete_success'));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
}

export function* watchAutomatedReportsSaga() {
  yield all([
    yield takeLatest(actions.getAutomatedReportsList.started, getAutomatedReportsListSaga),
    yield takeLatest(actions.createAutomatedReports.started, createAutomatedReportsSaga),
    yield takeLatest(actions.updateAutomatedReports.started, updateAutomatedReportsSaga),
    yield takeLatest(actions.deleteAutomatedReports.started, deleteAutomatedReportsSaga),
  ]);
}
